import React from 'react';
import styled from 'astroturf/react';

import CommentBase from 'js/social/Comment/Comment';
import * as types from 'js/social/shared/types';
import useShowToggle from 'js/social/shared/useShowToggle';
import _Container from "PostComments-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/PostComments.tsx?styleId=Container";
import _Comment from "PostComments-Comment.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/PostComments.tsx?styleId=Comment";
import _ClickToExpand from "PostComments-ClickToExpand.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/PostComments.tsx?styleId=ClickToExpand";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Comment = /*#__PURE__*/styled(CommentBase, null, {
  displayName: "Comment",
  styles: _Comment
});

const ClickToExpand = /*#__PURE__*/styled("button", null, {
  displayName: "ClickToExpand",
  styles: _ClickToExpand
});

type CommentProps = React.ComponentProps<typeof CommentBase>;

interface Props
  extends Omit<CommentProps, keyof types.Comment | 'parentCommentId'> {
  className?: string;
  comments: types.Comments;
  show: boolean;
  expandAll: boolean;
}

const PostComments: React.FunctionComponent<Props> = ({
  className,
  comments,
  show,
  expandAll,
  ...props
}) => {
  const hasSomeExpandedByDefault = comments.data.some(
    (comment) => comment.expandByDefault,
  );
  const renderShowMore =
    hasSomeExpandedByDefault &&
    !comments.data.every((comment) => comment.expandByDefault);

  // If none of the comments are expanded by default, we show all from the start
  const { isShown: showAll, show: expand } = useShowToggle(
    !hasSomeExpandedByDefault || expandAll,
  );

  const shouldShow = comments.data.length > 0 && (show || expandAll);
  if (!shouldShow) {
    return null;
  }

  return (
    <Container className={className} show={shouldShow}>
      {comments.data
        .filter((comment) => comment.expandByDefault || showAll || expandAll)
        .map((comment, index) => (
          <Comment
            key={`${comment.id}|${index}`}
            {...expand}
            {...comment}
            {...props}
          />
        ))}

      {renderShowMore && !(showAll || expandAll) && (
        <div style={{ marginLeft: 24 }}>
          <ClickToExpand onClick={expand}>Show more comments</ClickToExpand>
        </div>
      )}
    </Container>
  );
};

export default PostComments;
